import { GET_BOOKINGS } from '../actions/types';

const bookings = (state = {}, action) => {
  switch (action.type) {
    case GET_BOOKINGS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default bookings;